import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import { GetObservedDataOptions } from 'types/Meteorology/Fields/ObservedData/getOptions';
import { transformGetObservedDataOptionsResponse } from 'helper/Meteorology/Fields/ObservedData';

export const observedDataApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getObservedDataOptions: build.query<GetObservedDataOptions, void>({
      query: () => {
        const productKey = getProductKey('meteorologia');
        return {
          url: `produtos/dados-observados/painel-options/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetObservedDataOptionsResponse,
    }),
  }),
});

export const {
  useGetObservedDataOptionsQuery,
} = observedDataApi;
